import React, { useState } from 'react'
import * as components from '../../components'
import { ReportsService, RestService } from '../../services'
import * as ReactBootstrap from 'react-bootstrap'
import SlidingPane from 'react-sliding-pane'
import ScheduleReportForm from './ScheduleReportForm'
import { connect } from 'react-redux'
import * as rest from '../../services'
import { showErrorToast, showSuccessToast } from '../../state/toasts'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { getRights } from '../../state/rights'
import { getLists } from '../../state/lists'

const ScheduleReportFormPane = ({ report, OnSuccess }) => {
  const dispatch = useDispatch()
  const { rights } = useSelector((state) => state.userRights)
  const { report_types } = useSelector((state) => state.lists)
  const { user } = useSelector((state) => state.auth)
  const [isPaneOpen, setIsPaneOpen] = useState(false)
  const loadFormOption = () => {
    !rights && dispatch(getRights(user))
    !report_types && dispatch(getLists('REPORT_TYPES'))
  }

  let FormOrganization = ScheduleReportForm
  if (report) {
    FormOrganization = connect((state) => ({
      initialValues: { ...report },
    }))(ScheduleReportForm)
  }
  const onCreateOrUpdate = (values) => {
    if (!["SERIALIZABLE_INVENTORY_STOCK_REPORT",
    "LOANER_INVENTORY_STOCK_REPORT",
    "REPAIR_INVENTORY_STOCK_REPORT"].includes(values.report_type)){
      values.start_date = new Date(
        values.start_date.setDate(values.start_date.getDate() + 1)
     )
      values.start_date = values.start_date.toISOString().slice(0, 10)
      values.end_date = new Date(
      values.end_date.setDate(values.end_date.getDate() + 1)
    )
    values.end_date = values.end_date.toISOString().slice(0, 10)
    }else{
       values.start_date = new Date().toISOString().slice(0, 10)
      values.end_date = new Date().toISOString().slice(0, 10)

    }


    const promise = values.url
      ? new rest.ReportsService(values.url).makePutRequest(values)
      : new rest.ReportsService().makePostRequest(values)
    promise
      .then((response) => {
        dispatch(showSuccessToast('Success', 'Report has been scheduled'))
        OnSuccess()
      })
      .catch((errors) => {
        dispatch(showErrorToast('Error', errors.response.data))
      })
  }
  return (
    <>
      {!report ? (
        <ReactBootstrap.Button
          variant="dark"
          size="sm"
          onClick={() => setIsPaneOpen(true)}
        >
          {components.ICONS.PLUS}
        </ReactBootstrap.Button>
      ) : (
        <ReactBootstrap.Dropdown.Item
          onClick={(e) => {
            e.stopPropagation()
            setIsPaneOpen(true)
          }}
        >
          <i class="fa fa-edit" aria-hidden="true"></i> Edit
        </ReactBootstrap.Dropdown.Item>
      )}
      <SlidingPane
        overlayClassName="on-top"
        isOpen={isPaneOpen}
        title={report ? 'Edit Report' : 'Add New Report'}
        onAfterOpen={loadFormOption}
        onRequestClose={() => {
          setIsPaneOpen(false)
        }}
      >
        <FormOrganization
          rights={rights}
          report_types={report_types}
          onSubmit={onCreateOrUpdate}
        />
      </SlidingPane>
    </>
  )
}
export const ScheduledReportsDataGrid = ({
  results,
  page_size,
  current,
  count,
  onTableChange,
  onFilter,
}) => {
  const actionFormatter = (cell, row) => {
    return (
      <div onClick={(e) => e.stopPropagation()}>
        <ReactBootstrap.Dropdown>
          <ReactBootstrap.Dropdown.Toggle
            variant="dark"
            size="sm"
          ></ReactBootstrap.Dropdown.Toggle>
          <ReactBootstrap.Dropdown.Menu>
            <ReactBootstrap.Dropdown.Item
              disabled={!row.is_processed}
              onClick={() => {
                new ReportsService().download(
                  row.csv_download_url,row.report_path.replaceAll('/','-')
                )
              }}
            >
              Download CSV
            </ReactBootstrap.Dropdown.Item>
            <ReactBootstrap.Dropdown.Item
              disabled={!row.is_processed}
              onClick={() => {
                new ReportsService().download(
                  row.excel_download_url,row.report_path.replaceAll('/','-'),
                  'application/octet-stream'
                )
              }}
            >
              Download Excel
            </ReactBootstrap.Dropdown.Item>

            <ReactBootstrap.Dropdown.Item
              onClick={() => {
                RestService.call_url_action(`${row.url}run/`, 'POST')
              }}
            >
              Run Again
            </ReactBootstrap.Dropdown.Item>
          </ReactBootstrap.Dropdown.Menu>
        </ReactBootstrap.Dropdown>
      </div>
    )
  }

  const columns = [
    {
      dataField: 'organization_code',
      searchFieldKey: 'organization',
      text: 'Organization',
      type: 'string',
      searchFieldType: 'text',
      formatter: (cell, row) => {
        if (!cell) {
          cell = 'ALL'
        }
        return <div className="text-left"> {cell} </div>
      },
    },
    {
      dataField: 'report_type',
      text: 'Type',
      type: 'string',
      formatter: components.CellTextFormatter,
    },
    {
      dataField: 'start_date',
      text: 'Start Date',
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'select',
    },

    {
      dataField: 'end_date',
      text: 'End Date',
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'text',
    },
    {
      dataField: 'is_processed',
      text: 'Processed',
      type: 'string',
      formatter: components.BooleanConverter,
      searchFieldType: 'text',
    },
      {
      dataField: 'created_by',
      text: 'Created By'
    },
    {
      dataField: '',
      text: '',
      formatter: actionFormatter,
    },
  ]

  const getRowStyle = (item, rowIndex) => {
    const style = {}
    if (item.is_processed) {
      style.borderLeft = '10px solid Green'
      return style
    }
    style.borderLeft = '10px solid Red'
    return style
  }
  return (
    <ReactBootstrap.Card>
      <ReactBootstrap.Card.Header className="card-header bg-dark text-white">
        <ReactBootstrap.Row>
          <ReactBootstrap.Col xs={6}>Reports</ReactBootstrap.Col>
          <ReactBootstrap.Col className="text-end" xs={6}>
            <components.Slider
              size="sm"
              title={components.ICONS.SEARCH}
              sliderWidth={"20vw"}
              header={
                <span className="pr-3">
                  {components.ICONS.SEARCH}
                  <span className="pl-1"> Search Reports</span>
                </span>
              }
            >
              <components.GenericSearchForm
                onFilter={onFilter}
                columns={columns}
              />
            </components.Slider>
            <ScheduleReportFormPane OnSuccess={onFilter} />
            <ReactBootstrap.Button
              onClick={() => onFilter()}
              variant="dark"
              size="sm"
            >
              {components.ICONS.REFRESH}
            </ReactBootstrap.Button>
          </ReactBootstrap.Col>
        </ReactBootstrap.Row>
      </ReactBootstrap.Card.Header>
      <ReactBootstrap.Card.Body>
        <components.DataGrid
          data={results || []}
          rowStyle={getRowStyle}
          sizePerPage={page_size || 10}
          page={current || 1}
          columns={columns}
          count={count || 0}
          onTableChange={onTableChange}
        />
      </ReactBootstrap.Card.Body>
    </ReactBootstrap.Card>
  )
}
